import { environment } from '../../../environments/environment';
import { Utility } from '../utility';

export const emojiHuHu = {
    label: '糊糊',
    height: 90,
    width: 90,
    path:"/upload/facetime/huhu/",
    range:[[20210201,20210220]]
    // items: [
    //     {
    //         'not': 20210201,
    //         'id': 20210201,
    //         'image': '/upload/facetime/huhu/20210201.gif',
    //         'title': 'mua',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210201)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210202,
    //         'id': 20210202,
    //         'image': '/upload/facetime/huhu/20210202.gif',
    //         'title': '饱了',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210202)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210203,
    //         'id': 20210203,
    //         'image': '/upload/facetime/huhu/20210203.gif',
    //         'title': '崇拜',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210203)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210204,
    //         'id': 20210204,
    //         'image': '/upload/facetime/huhu/20210204.gif',
    //         'title': '打招呼',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210204)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210205,
    //         'id': 20210205,
    //         'image': '/upload/facetime/huhu/20210205.gif',
    //         'title': '俯卧撑',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210205)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210206,
    //         'id': 20210206,
    //         'image': '/upload/facetime/huhu/20210206.gif',
    //         'title': '害羞',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210206)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210207,
    //         'id': 20210207,
    //         'image': '/upload/facetime/huhu/20210207.gif',
    //         'title': '揪耳朵',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210207)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210208,
    //         'id': 20210208,
    //         'image': '/upload/facetime/huhu/20210208.gif',
    //         'title': '哦豁',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210208)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210209,
    //         'id': 20210209,
    //         'image': '/upload/facetime/huhu/20210209.gif',
    //         'title': '祈祷',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210209)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210210,
    //         'id': 20210210,
    //         'image': '/upload/facetime/huhu/20210210.gif',
    //         'title': '认输',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210210)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210211,
    //         'id': 20210211,
    //         'image': '/upload/facetime/huhu/20210211.gif',
    //         'title': '送花花',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210211)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210212,
    //         'id': 20210212,
    //         'image': '/upload/facetime/huhu/20210212.gif',
    //         'title': '叹气',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210212)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210213,
    //         'id': 20210213,
    //         'image': '/upload/facetime/huhu/20210213.gif',
    //         'title': '挖鼻',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210213)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210214,
    //         'id': 20210214,
    //         'image': '/upload/facetime/huhu/20210214.gif',
    //         'title': '委屈',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210214)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210215,
    //         'id': 20210215,
    //         'image': '/upload/facetime/huhu/20210215.gif',
    //         'title': '嘻嘻',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210215)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210216,
    //         'id': 20210216,
    //         'image': '/upload/facetime/huhu/20210216.gif',
    //         'title': '心碎',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210216)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210217,
    //         'id': 20210217,
    //         'image': '/upload/facetime/huhu/20210217.gif',
    //         'title': '耶！',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210217)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210218,
    //         'id': 20210218,
    //         'image': '/upload/facetime/huhu/20210218.gif',
    //         'title': '疑惑',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210218)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210219,
    //         'id': 20210219,
    //         'image': '/upload/facetime/huhu/20210219.gif',
    //         'title': '郁闷',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210219)',
            
    //         'GroupID': 202102
    //     },
    //     {
    //         'not': 20210220,
    //         'id': 20210220,
    //         'image': '/upload/facetime/huhu/20210220.gif',
    //         'title': '自恋',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210220)',
            
    //         'GroupID': 202102
    //     },
    // ]
}
